import { Card, CardContent } from '@/components/ui/card';

type Props = {
  overview: string;
};

export function ReviewOverview({ overview }: Props) {
  if (!overview) return null;

  return (
    <Card variant="flat">
      <CardContent className="py-4">
        <h3 className="text-sm font-medium mb-2">Panoramica</h3>
        <p className="text-sm leading-relaxed whitespace-pre-line">{overview}</p>
      </CardContent>
    </Card>
  );
}
